import { render, staticRenderFns } from "./wechatMsg_node_form.vue?vue&type=template&id=2da9cda3&"
import script from "./wechatMsg_node_form.vue?vue&type=script&lang=js&"
export * from "./wechatMsg_node_form.vue?vue&type=script&lang=js&"
import style0 from "./wechatMsg_node_form.vue?vue&type=style&index=0&id=2da9cda3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports